<template>
  <div>
    <label>{{ titleKey | setText(title) }}</label>
    <select
      :disabled="disabled"
      @change="input"
      v-model="val"
      class="form-control mb-2"
    >
      <option value="">Выберите</option>
      <option :value="l[valueKey]" v-for="(l, k) in list" :key="k">
        {{ l[labelKey] }}
      </option>
    </select>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    data: {
      default: function () {
        return {};
      },
    },
    disabled: {
      default: false,
    },
    link: {
      default: "",
    },
    staticFilterKey: {
      default: null,
    },
    staticFilterId: {
      default: null,
    },
    title: {
      default: "",
    },
    titleKey: {
      default: "",
    },
    labelKey: {
      default: "name",
    },
    valueKey: {
      default: "id",
    },
    method: {
      default: "GET",
    },
    dataKey: {
      default: "data",
    },
  },
  async created() {
    await this.getList();
  },
  watch: {
    link(val) {
      if (val) {
        this.getList();
      }
    },
    staticFilterId(val) {
      this.val = null;
      this.$emit("input", null);
      this.getList();
    },
  },
  methods: {
    input() {
      setTimeout(() => {
        this.$emit("input", this.val);
      }, 10);
    },
    getList() {
      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}${this.link}`,
        method: this.method,
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        data: this.data,
      })
        .then((response) => {
          if (response.data) {
            this.list = this.dataKey
              ? response.data[this.dataKey]
              : response.data;

            if (this.staticFilterKey) {
              this.list = this.list.filter(
                (entry) => entry[this.staticFilterKey] == this.staticFilterId
              );
            }
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      list: [],
      val: null,
    };
  },
};
</script>

